// extracted by mini-css-extract-plugin
export default {"filter-section":"ExerciseFilterSection_filter-section__-58Ku App_card__1zT54","legend":"ExerciseFilterSection_legend__WJ62K"};